import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, withDebugTracing } from '@angular/router';
import { first, Subject, subscribeOn, takeUntil } from 'rxjs';
import { LocalStorageService } from 'src/app/services/local-storage.service';

export interface customBreadCrumbRequest {
  oldString: string;
  newString: string;
}

@Component({
  selector: 'app-bread-crumbs',
  templateUrl: './bread-crumbs.component.html',
  styleUrls: ['./bread-crumbs.component.scss'],
  standalone: false,
})
export class BreadCrumbsComponent implements OnInit, AfterViewInit, OnDestroy {
  urlPage: string = '';
  urls: string[] = [];
  divider: string = ' ⟩ ';
  baseUrl: string = window.location.host;
  firstLoad: boolean = true;
  lastUrl: string = '';

  private theEnd$ = new Subject<void>();


  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    let protocol = window.location.protocol;
    let domain = window.location.host;
    this.baseUrl = `${protocol}//${domain}`;

    /*let url = window.location.href;
    url = url.split("/").slice(3).join("/");
    url = url.replace(new RegExp('-', 'g'), " ");
    url = url.replace("%20", " ");

    url = this.makeUrlCooler(url);

    this.urls = url.split("/");

    this.urls.forEach((u,index)=>{
      this.urls[index] = this.urls[index].split(';')[0]
    })*/
    /*let url = window.location.href
    .replace('%20', ' ')
    .replace(/-/g, ' ');*/
    let url = window.location.href.split('/').slice(3).join('/');

    url = url.replace(/-/g, ' ').replace(/%20/g, ' ');

    if (url.includes('dashboard')) {
      this.firstLoad = false;
    }

    url = this.makeUrlCooler(url);

    const arr = url.split('/');
    this.urls = arr.map((u) => u.split(';')[0]);
    this.lastUrl = this.urls[this.urls.length - 1];
    //this.localStorageService.setLastUrl(this.lastUrl);

    console.error('this tha url');
    console.error(this.urls);

    /*this.router.events.subscribe((val: any) => {
      if (val instanceof NavigationEnd) {
        //console.warn(val.urlAfterRedirects);
        let url: string = val.urlAfterRedirects;
        url = url.replace("%20", " ");
        url = this.makeUrlCooler(url);
        // url.replace(new RegExp('/','g'),' > ');
        this.firstLoad=false;
        let arr = url.split('/');

        //console.error(arr);
        this.urls = arr;
        this.urls.forEach((u,index)=>{
          this.urls[index] = this.urls[index].split(';')[0]
        })
        this.lastUrl = this.urls[this.urls.length-1]
        this.localStorageService.setLastUrl(this.lastUrl);
        console.error("This da url from router");
        console.error(this.urls)
      }

    });*/
    this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.firstLoad = false;

        // now `e` is narrowed to NavigationEnd, so urlAfterRedirects is available
        let url = e.urlAfterRedirects.replace('%20', ' ').replace(/-/g, ' ');
        url = this.makeUrlCooler(url);

        const arr = url.split('/');
        this.urls = arr.map((u) => u.split(';')[0]);
        this.lastUrl = this.urls[this.urls.length - 1];
        //this.localStorageService.setLastUrl(this.lastUrl);
      }
    });

    this.localStorageService.breadCrumSub$.pipe(takeUntil(this.theEnd$)).subscribe({
      next: (data: customBreadCrumbRequest) => {
        console.warn(`\n \n GOT DATA \n \n `);
        console.warn(data);
        let i = this.urls.findIndex(x => x == data.oldString);
        if(i > -1) {
          this.urls[i] = data.newString;
        }else{
          let oldData = data.oldString.replaceAll('-', ' ');
          let i = this.urls.findIndex(x => x == oldData);
          if(i > -1) {
          this.urls[i] = data.newString;
          }
        }
      }
    });
  }

  makeUrlCooler(url: string): string {
    url = url.replace('stepper/', '');
    //url = url.replace('dashboard', '');
    if (url.includes('dashboard')) {
      url = '';
    }
    return url;
  }

  redirect(u: string, index: number) {
    if (u == '/home' && index == 0) {
      this.router.navigate(['/home/dashboard']);
    } else {
      console.log(this.urls[index]);
      let uu = '';
      for (let i = 0; i <= index; i++) {
        if (this.urls[i] === ' ' || this.urls[i] === '') {
          continue;
        }
        uu = `${uu}/${this.urls[i]}`;
      }
      console.log(uu);
      this.router.navigate([uu]);
    }
  }

  ngAfterViewInit(): void {
   
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }
}
